import { entryPoint } from '../entry';
import { AccountApp } from './AccountApp';
import { ClusterApp } from './ClusterApp';

/**
 * The one branch in the application.
 *
 * Which console this is was settled by the host the page came from, before any
 * of this ran. Below this line the two trees share no session, no API client
 * and no screens — an account session cannot be shown a cluster screen because
 * the cluster screens are not mounted, their API client does not exist in this
 * tree, and the addresses that reach them do not parse on this host.
 */
export function App() {
  const entry = entryPoint();
  return entry.kind === 'account' ? <AccountApp /> : <ClusterApp tenancyDomain={entry.tenancyDomain} />;
}
